import { EMPTY_ALLOWABLE_FIELDS } from '@rover/shared/js/constants/searchPage.constants';
import { searchFilterKeysMap } from '@rover/shared/js/search/utilities/searchFiltersMap';
import { SearchFilters } from '@rover/types';

/**
 * Checks non-boolean and non-numeric types if they are empty or falsy
 * @param val
 * @returns boolean
 */
export const isFalsyOrEmpty = (val: any): boolean => {
  // Note: the value false will return false here because we want to maintain the ability to explicitly pass 'false'
  if (val instanceof Date) return false;
  return (
    (typeof val === 'string' && !val.length) ||
    typeof val === 'undefined' ||
    val === null ||
    (Array.isArray(val) && !val.length) ||
    (typeof val === 'object' && Object.keys(val).length === 0)
  );
};

/**
 * @description This function iterates through all fields in the object and removes any invalid or empty fields
 * @param filters
 * @returns clone of object with no empty kv pairs
 */
export const removeEmptyKeys = <T extends object>(filters: T): Partial<T> => {
  if (typeof filters !== 'object') return filters;
  const o = { ...filters };

  Object.keys(o).forEach(
    (k) => !EMPTY_ALLOWABLE_FIELDS.has(k) && isFalsyOrEmpty(o[k]) && delete o[k]
  );

  return o;
};

/**
 *
 * @param filters
 * @returns an object with all keys that exist in searchFilterKeysMap snakeified
 */
export const snakeifyKeys = (filters: Partial<SearchFilters>): Record<string, string> => {
  if (typeof filters !== 'object') return filters;
  const snakeFilters = {};

  Object.keys(filters).forEach((filterKey) => {
    if (searchFilterKeysMap[filterKey]) {
      if (Array.isArray(filters[filterKey])) {
        snakeFilters[searchFilterKeysMap[filterKey]] = filters[filterKey];
      } else {
        snakeFilters[searchFilterKeysMap[filterKey]] = filters[filterKey].toString();
      }
    }
  });

  return snakeFilters;
};
